import { RefreshIcon } from '@/components/icons'
import { LoadingButton } from '@mui/lab'
import { SxProps, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

interface FunctionButtonProps {
  onClick?: any
  disable?: any
  isLoading?: boolean
  sx?: SxProps
  text?: string
  decoders?: boolean
}

const FunctionButton = ({
  onClick,
  disable,
  isLoading,
  sx,
  text = 'Button',
  decoders,
}: FunctionButtonProps) => {
  const [loadingButton, setLoadingButton] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setLoadingButton(false)
      }, 500)
    }
  }, [isLoading])

  const handleClick = () => {
    setLoadingButton(true)
    onClick()
  }

  return (
    <LoadingButton
      startIcon={decoders && <RefreshIcon sx={{ color: '#fff' }} />}
      loading={loadingButton}
      sx={{
        backgroundColor: 'rgba(0, 71, 68, 0.6)',
        borderRadius: '3px',
        width: 'auto',
        minWidth: '32px',
        height: '20px',
        whiteSpace: 'nowrap',
        '&:hover': {
          backgroundColor: 'rgba(0, 71, 68, 0.6)',
        },
        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.26)',
          boxShadow: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
        },
        ...sx,
      }}
      disabled={disable}
      onClick={handleClick}
    >
      <Typography
        sx={{
          color: 'common.white',
          padding: '4px 8px',
        }}
      >
        {text}
      </Typography>
    </LoadingButton>
  )
}

export default FunctionButton
